export let GiveawayTypes = /*#__PURE__*/function (GiveawayTypes) {
  GiveawayTypes["swag"] = "swag";
  GiveawayTypes["goodie"] = "goodie";
  return GiveawayTypes;
}({});
export let GiveawayGoodieSteps = /*#__PURE__*/function (GiveawayGoodieSteps) {
  GiveawayGoodieSteps["catalog"] = "catalog";
  GiveawayGoodieSteps["checkout"] = "checkout";
  return GiveawayGoodieSteps;
}({});